<template>
  <el-dialog
    title="上传图片"
    :visible.sync="visible"
    width="820px"
    :close-on-click-modal="false"
    show-close
    :before-close="() => dislogClose()"
  >
    <template slot="title">
      <div class="d-flex align-items-center">
        <div>{{ $l('form_label_upload_picture') || '上传图片' }}</div>
        <el-divider direction="vertical"></el-divider>
        <div>
          <el-upload
            multiple
            action="/oss/ossUploadReturnUrlAndFileId"
            :file-list="listImageFile"
            :show-file-list="false"
            :auto-upload="false"
            :on-change="onImageChange"
            accept=".jpeg,.jpg,.png,.gif"
          >
            <el-button slot="trigger" size="mini" type="primary">
              {{ $l('btn_select_picture') || '选取图片' }}</el-button
            >
          </el-upload>
        </div>
      </div>
    </template>
    <div
      v-if="isEmpty"
      style="height: 400px;"
      class="d-flex align-items-center justify-content-center"
    >
      <div style="text-align: center">
        <img src="/image/static/img/nodata.png" />
        <p class="no-data mt-1">
          {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
        </p>
      </div>
    </div>
    <div v-if="!isEmpty" class="upload-draggable-body">
      <vuedraggable
        @end="draggableEnd"
        tag="div"
        draggable=".draggable-item"
        class="d-flex flex-wrap"
      >
        <div
          v-for="(item, index) in listImageSrc"
          :key="index"
          class="draggable-item"
        >
          <el-tooltip
            placement="top"
            :content="$l('tooltip_mouse_click_drag') || '鼠标点击拖动'"
          >
            <div class="image-box">
              <el-image
                style="width: 100%; height: 100%"
                fit="scale-down"
                :src="item"
                :preview-src-list="listImageSrc"
              ></el-image>
              <div
                class="shadow d-flex align-items-center justify-content-center"
              >
                <div>
                  <span @click="onImagePreview(index)" class="mr-2">
                    <i class="el-icon-zoom-in"></i
                  ></span>
                  <span @click="onImageRemove(index)">
                    <i class="el-icon-delete"></i
                  ></span>
                </div>
              </div>
            </div>
          </el-tooltip>
        </div>
      </vuedraggable>
    </div>
    <div v-show="false" class="imagesViewer" v-viewer="{ movable: true }">
      <img
        v-for="(item, index) in listImageSrc"
        :src="item || '/image/static/img/nopic.jpg'"
        :key="index"
      />
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="dislogClose()">{{
        $l('INDEX.btn_cancel') || '取消'
      }}</el-button>
      <el-button size="small" type="primary" @click="upload()">{{
        $l('INDEX.btn_upload') || '上传'
      }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import vuedraggable from 'vuedraggable'
export default {
  props: {
    materialCode: String,
    visible: {
      type: Boolean,
      default: false,
    },
  },
  components: { vuedraggable },
  data() {
    return {
      listImageFile: [],
      viewer: null,
    }
  },
  computed: {
    isEmpty() {
      return !this.listImageFile || !this.listImageFile.length
    },
    listImageSrc() {
      return this.listImageFile.map((file) => {
        if (file.raw) {
          return URL.createObjectURL(file.raw)
        }
        return file.originImageUrl
      })
    },
    readyImages() {
      return this.listImageFile.filter((file) => {
        if (file.status && 'ready' === file.status) return file
      })
    },
  },
  mounted() {
    this.loadImages()
  },
  methods: {
    loadImages() {
      if (!this.materialCode) return
      this.$api
        .materialInfoImageListApi({ materialCode: this.materialCode })
        .then((res) => {
          const data = res.body.data
          this.listImageFile = data
        })
    },
    dislogClose() {
      this.$confirm('您确认取消此次上传？')
        .then(() => {
          this.$emit('close')
        })
        .catch(() => {})
    },
    onImageRemove(index) {
      this.listImageFile.splice(index, 1)
    },
    onImagePreview(index) {
      // 点击大图显示图片预览组件
      if (this.listImageSrc.length) {
        this.viewer = this.$el.querySelector('.imagesViewer').$viewer
        this.viewer.view(index)
        this.viewer.show()
      }
    },
    onImageChange(file, fileList) {
      this.listImageFile = fileList
    },
    async upload() {
      if (this.isEmpty) {
        this.$message.warning(`请选择您需要上传的资料！`)
        return
      }
      const listImage = await this.uploadImages()

      for (let i in listImage) {
        for (let j in this.listImageFile) {
          if (listImage[i].uid === this.listImageFile[j].uid) {
            this.listImageFile[j] = listImage[i]
          }
        }
      }

      const parms = {
        materialCode: this.materialCode,
        listImage: this.listImageFile,
      }

      this.$api.materialInfoImageBatchUploadApi(parms).then((res) => {
        this.$message({
          showClose: true,
          message: res.msg,
          type: 'success',
        })
        this.$emit('close')
        this.$emit('reload')
      })
    },
    /**
     * 上传图片
     * @return 上传成功后的图片信息
     */
    uploadImages() {
      if (this.isEmpty) {
        return Promise.resolve([])
      }

      const uploadTask = this.readyImages.map((image) => {
        return this.$api.SYS_UPLOAD(image.raw).then((res) => ({
          originImageCode: res.body.fileId,
          originImageUrl: res.body.url,
          originImageSpec: image.raw.type,
          uid: image.uid,
        }))
      })

      return Promise.all(uploadTask)
    },
    draggableEnd({ newIndex, oldIndex }) {
      if (newIndex === oldIndex) return
      const oldEl = { ...this.listImageFile[oldIndex] }

      if (newIndex < oldIndex) {
        for (let i = oldIndex; i > newIndex; i--) {
          this.listImageFile[i] = this.listImageFile[i - 1]
        }
      } else if (newIndex > oldIndex) {
        for (let i = newIndex; i < oldIndex; i++) {
          this.listImageFile[i] = this.listImageFile[i + 1]
        }
      }
      this.listImageFile[newIndex] = oldEl
    },
  },
}
</script>
<style lang="scss" scoped>
.image-box {
  width: 140px;
  height: 140px;
  line-height: 140px;
  position: relative;
  background-color: #fbfdff;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  margin: 8px;
}
.image-box:hover {
  .shadow {
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 1;
  }
}

.upload-draggable-body {
  min-height: 400px;
}

.shadow {
  position: absolute;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  border-radius: 6px;
  opacity: 0;
  transition: opacity 0.3s;
  color: #fff;
  font-size: 20px;
  line-height: 20px;
  padding: 2px;
}
</style>
